import React, { ReactNode } from 'react';

import { Box } from '@vk-hr-tek/ui/Box';

interface WithRightAreaProps {
  children: ReactNode | ReactNode[];
  height?: string | number;
}

export const WithRightArea = ({
  children,
  height = '100%',
}: WithRightAreaProps) => {
  return (
    <Box display="flex" justifyContent="space-between" height={height}>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        height="100%"
        overflow="auto"
        id="scrollable-target"
      >
        {children}
      </Box>
      <Box id="page-right-area" />
    </Box>
  );
};
